"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueErrorMessages = exports.ErrorToasts = void 0;
const tslib_1 = require("tslib");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const reselect_1 = require("reselect");
const UIActionsToast_1 = require("../../UIActionsToast");
/**
 * Renders the errors in a containing ErrorList React Context as toasts (UIActionsToast).
 * Deduplicates error messages so that, at most, one of any given message is shown.
 */
class ErrorToasts extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.memoizedGetUniqueErrorMessages = (0, reselect_1.defaultMemoize)(getUniqueErrorMessages);
    }
    renderToastForMessage(message, key) {
        switch (message) {
            case (0, data_catalog_shared_1.getToastMessageForErrorCode)('BACKFILL_RUNNING'):
                // show a warning toast instead of a full blown error toast
                return react_1.default.createElement(UIActionsToast_1.UIActionsToast, { key: key, type: 'warning', text: message });
            case (0, data_catalog_shared_1.getToastMessageForErrorCode)('PERMISSIONS_MODE_SWITCHED'):
                // we don't expect to hit this, but if we do, log it and don't render a toast
                console.log((0, data_catalog_shared_1.getToastMessageForErrorCode)('PERMISSIONS_MODE_SWITCHED'));
                return null;
            default:
                return react_1.default.createElement(UIActionsToast_1.UIActionsToast, { key: key, type: 'error', text: message });
        }
    }
    render() {
        return (react_1.default.createElement(data_catalog_shared_1.ErrorListContext.Consumer, null, errorList => {
            const errorMessages = this.memoizedGetUniqueErrorMessages(errorList.errors);
            return errorMessages.map((message, i) => {
                return this.renderToastForMessage(message, i);
            });
        }));
    }
}
exports.ErrorToasts = ErrorToasts;
function getUniqueErrorMessages(errors) {
    const errorMessages = [];
    const seenErrorMessages = {};
    for (const error of errors) {
        const errorMessage = error.errorMessage;
        if (!seenErrorMessages[errorMessage]) {
            seenErrorMessages[errorMessage] = true;
            errorMessages.push(errorMessage);
        }
    }
    return errorMessages;
}
exports.getUniqueErrorMessages = getUniqueErrorMessages;
//# sourceMappingURL=ErrorToasts.js.map